import React from 'react';
import AppDetailsView from './AppDetailsView';
import useAppDetailsLogic from './AppDetailsLogic';

/**
 * App Details Page
 * Connects the logic and view according to the project architecture
 */
const AppDetailsPage = () => {
  // Use the custom logic hook for this page
  const {
    fileId,
    appDetails,
    analysisResults,
    isLoading,
    error,
    permissionsData,
    updateStatus,
    uploadNewVersion,
    moveToNextStage
  } = useAppDetailsLogic();

  return (
    <AppDetailsView
      appDetails={appDetails}
      analysisResults={analysisResults}
      isLoading={isLoading}
      error={error}
      permissionsData={permissionsData}
      uploadNewVersion={uploadNewVersion}
      moveToNextStage={moveToNextStage}
    />
  );
};

export default AppDetailsPage; 